import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import forwardRefWithTranslation from '@/common/forwardRefWithTranslation';

const { classNames } = Mobi2Go.helpers;

class Autocomplete extends React.Component {
    static propTypes = {
        search_query: PropTypes.string.isRequired,
        show_logo: PropTypes.bool.isRequired,
        highlighted_item: PropTypes.shape({
            id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
                .isRequired,
        }),
        list: PropTypes.arrayOf(
            PropTypes.shape({
                description: PropTypes.string,
                sub_text: PropTypes.string,
                matched_substrings: PropTypes.array,
                terms: PropTypes.array,
            })
        ).isRequired,
        onItemSelect: PropTypes.func.isRequired,
        onItemHighlight: PropTypes.func.isRequired,
        onMouseEnter: PropTypes.func.isRequired,
        onMouseLeave: PropTypes.func.isRequired,
        onSavedAddressDeleteClick: PropTypes.func.isRequired,
        t: PropTypes.func.isRequired,
    };

    static defaultProps = {
        highlighted_item: null,
    };

    // eslint-disable-next-line class-methods-use-this
    emphasisMatchedStrings(description, matched_substrings) {
        const elements = [];
        let index = 0;
        matched_substrings.forEach(match => {
            elements.push(description.substr(index, match.offset - index));
            elements.push(
                <strong key={match.offset}>
                    {description.substr(match.offset, match.length)}
                </strong>
            );
            index = match.offset + match.length;
        });
        if (index !== description.length) {
            elements.push(description.substr(index));
        }

        return <span>{elements}</span>;
    }

    shouldShowNoResults() {
        const { search_query, list } = this.props;

        return (
            search_query &&
            _.filter(list, item => item.matched_substrings.length).length === 0
        );
    }

    render() {
        const {
            t,
            onMouseEnter,
            onMouseLeave,
            search_query,
            list,
            onItemSelect,
            onItemHighlight,
            highlighted_item,
            onSavedAddressDeleteClick,
            show_logo,
        } = this.props;

        return (
            <div
                className="m2g-autocomplete-container"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <div className="m2g-locations-finder-address-search-autocomplete m2g-autocomplete">
                    <div
                        className="m2g-autocomplete-list"
                        ref={element => {
                            this.list_element = element;
                        }}
                    >
                        {this.shouldShowNoResults() && (
                            <div className="m2g-locations-finder-address-search-autocomplete-no-results m2g-text--small m2g-text--offset">
                                {t('no_matches_found')}
                                {' "'}
                                <span className="m2g-text--italic">
                                    {search_query}
                                </span>
                                &quot;
                            </div>
                        )}
                        {list.map(
                            item => (
                                <div
                                    key={item.id}
                                    role="button"
                                    tabIndex="0"
                                    onKeyPress={() => {}}
                                    onClick={onItemSelect.bind(this, item)}
                                    onFocus={onItemHighlight.bind(this, item)}
                                    onMouseEnter={onItemHighlight.bind(
                                        this,
                                        item
                                    )}
                                    onTouchStart={onItemSelect.bind(this, item)}
                                    ref={
                                        highlighted_item &&
                                        highlighted_item.id === item.id
                                            ? element => {
                                                  this.highlighted_element = element;
                                              }
                                            : null
                                    }
                                    className={classNames(
                                        'm2g-autocomplete-item',
                                        {
                                            'm2g-autocomplete-item--no-icon':
                                                item.type === 'region',
                                            'm2g-autocomplete-item--highlighted':
                                                highlighted_item &&
                                                highlighted_item.id === item.id,
                                        }
                                    )}
                                >
                                    {item.type !== 'region' && (
                                        <span
                                            className={classNames(
                                                'm2g-icon',
                                                'm2g-autocomplete-item-icon',
                                                {
                                                    'm2g-icon--star':
                                                        item.type ===
                                                        'saved_address',
                                                    'm2g-icon--location':
                                                        item.type !==
                                                        'saved_address',
                                                }
                                            )}
                                        />
                                    )}
                                    <span className="m2g-autocomplete-item-text">
                                        {this.emphasisMatchedStrings(
                                            item.description,
                                            item.matched_substrings
                                        )}
                                    </span>
                                    {item.subtext && (
                                        <div className="m2g-autocomplete-item-subtext m2g-text--offset m2g-text--small">
                                            {item.subtext}
                                        </div>
                                    )}
                                    {item.type === 'saved_address' && (
                                        // eslint-disable-next-line jsx-a11y/control-has-associated-label
                                        <span
                                            role="button"
                                            tabIndex="0"
                                            onKeyPress={() => {}}
                                            className={classNames(
                                                'm2g-icon',
                                                'm2g-icon--cross',
                                                'm2g-autocomplete-item-icon-right'
                                            )}
                                            onClick={e => {
                                                onSavedAddressDeleteClick(
                                                    item.address
                                                );
                                                e.stopPropagation();
                                            }}
                                        />
                                    )}
                                </div>
                            ),
                            this
                        )}
                    </div>
                    {show_logo && (
                        <div className="m2g-autocomplete-logo-container">
                            <img
                                className="m2g-autocomplete-logo m2g-autocomplete-logo--on-light"
                                src={`${Mobi2Go.app.base_url}/store/application/v3/dist/img/maps/powered-by-google-on-white.png`}
                                alt="Powered by google"
                            />

                            <img
                                className="m2g-autocomplete-logo m2g-autocomplete-logo--on-dark"
                                src={`${Mobi2Go.app.base_url}/store/application/v3/dist/img/maps/powered-by-google-on-non-white.png`}
                                alt="Powered by google"
                            />
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default forwardRefWithTranslation('locations.finder')(Autocomplete);
